<template>
   <div class="about-fifth-section" v-if="about != null" id="section-architecture">
        <div class="container">
            <div class="column-container">
                <div class="section-title section-title-mobile">
                    <h5>{{about.upper_title}}</h5>
                    <h2>{{about.title}}</h2>
                </div>
               <div class="col-left">
                   <div class="genplan-pic">
                       <img :src="about.img" alt="">
                   </div>
               </div>
               <div class="col-right">
                    <div class="section-title">
                        <h5>{{about.upper_title}}</h5>
                        <h2>{{about.title}}</h2>
                    </div>
                    <div class="genplan-pins">
                        <div class="pin" v-for="pin in about.pins">
                            <img :src="pin.icon" alt="">
                            <span>{{pin.name}}</span>
                        </div>
                    </div>
                </div>
           </div>
        </div>
        <div class="mobile-desc-help">
            <svg-icon icon-class="move-map" className="icon-move-map"/>
            <p>Вы можете увеличивать и перемещать карту</p>
        </div>
        <div class="genplan-mobile">
            <img :src="about.img" alt="" id="genplan-mobile">
        </div>
        <div class="genplan-pins-mobile">
            <div class="pin" v-for="pin in about.pins">
                <img :src="pin.icon" alt="">
                <span>{{pin.name}}</span>
            </div>
        </div>
   </div>
</template>

<script>
    export default {
        name: 'about-fifth-second',
        components: {
        },
        data () {
            return {
            }
        },
        methods: { 
            initPinchZoomer() {
                if ($(window).width() < 740) {
                    $("#genplan-mobile").pinchzoomer({
                        initZoom: 1.2,
                        minZoom: 1.2,
                        maxZoom: 2,
                    });
                }
            }
        },
        computed: {
            about() {
                return this.$store.state.about.about_fifth_elem
            }
        },
        created () {
        },
        mounted () {
            this.$store.watch(
                (state) => state.about,
                (newValue) => {
                    if (newValue) {
                        var _self = this;
                        var image = new Image();
                        image.onload = function () {
                            // console.log('work');
                            _self.initPinchZoomer();
                        }
                        image.src = newValue.about_fifth_elem.img;
                    }
                }
            )
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about-elems/about-elem-fifth.scss';
    @import '@/styles/components/about/about-media/5-media.scss';
</style>